"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoldspotAuthConfig = void 0;
// AUTHENTICATION WITH COGNITO USING AMPLIFY UI
// https://ui.docs.amplify.aws/components/authenticator
var aws_amplify_1 = require("aws-amplify");
var default_endpoints_1 = require("./default-endpoints");
/**
 * Should be in the root of the app, above the `ReactDOM.render`
 *
 * Initializes Amplify Auth in the app. Uses environment variables:
 *
 * ```
 * REACT_APP_REGION
 * REACT_APP_USER_POOL_ID
 * REACT_APP_USER_POOL_WEB_CLIENT_ID
 * ```
 *
 * defaults to Goldspot test user pool and always includes the test
 * endpoint: "GatewayGoldSpotTest".
 *
 * @example
 * ```
 * import { GoldspotAuthConfig } from "gsf-util-react-auth";
 * import { Auth } from "aws-amplify";
 *
 * GoldspotAuthConfig([
 *  {
 *    "name": "FileGroupAPI",
 *    "endpoint": "https://filegroup.api.goldspot.ca",
 *    "custom_headers": async () => {
 *      return {
 *        "Authorization": `Bearer ${(await Auth.currentSession())
 *          .getIdToken()
 *          .getJwtToken()}`,
 *        "Content-Type": "application/json"
 *      }
 *    }
 *  }
 * ])
 * ```
 */
var GoldspotAuthConfig = function (endpoints) {
    aws_amplify_1.Amplify.configure({
        // These environments should be set locally and in Amplify deployment.
        // Fallback to GS test user pool
        // Auth: {
        //   region: process.env.REACT_APP_REGION || 'us-west-1',
        //   userPoolId: process.env.REACT_APP_USER_POOL_ID || 'us-west-1_YpkY0J7xQ',
        //   userPoolWebClientId:
        //     process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID ||
        //     '5le4mn956di7l8gjqmfd07s165',
        // },
        Auth: {
            region: process.env.REACT_APP_REGION || 'us-west-1',
            userPoolId: process.env.REACT_APP_USER_POOL_ID || 'us-west-1_YpkY0J7xQ',
            userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID ||
                '5le4mn956di7l8gjqmfd07s165',
            mandatorySignIn: true,
            oauth: {
                domain: process.env.REACT_APP_HOSTED_UI_DOMAIN || 'gs-platform-test.auth.us-west-1.amazoncognito.com',
                scope: ['openid'],
                redirectSignIn: process.env.REACT_APP_REDIRECT_SIGN_IN || 'http://localhost:3000',
                redirectSignOut: process.env.REACT_APP_REDIRECT_SIGN_IN || 'http://localhost:3000',
                responseType: 'code',
            },
        },
        // https://docs.amplify.aws/lib/restapi/authz/q/platform/js/
        API: {
            endpoints: __spreadArray(__spreadArray([], default_endpoints_1.defaultEndpoints, true), endpoints, true),
        },
    });
};
exports.GoldspotAuthConfig = GoldspotAuthConfig;
